<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('user.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('user.pageTitle'),
            href: '/users'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <fieldset>
            <legend>{{ $t('user.userAccount') }}</legend>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <ts-loading-banner :loading="loading">
                    <div class="col-md-12">
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.name')
                        }}</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors.has('name') }"
                            v-model.trim="model.name"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('name')"
                          >
                            {{ errors.first('name') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.userName')
                        }}</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors.has('username') }"
                            v-model.trim="model.username"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('username')"
                          >
                            {{ errors.first('username') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.type')
                        }}</label>
                        <div class="col-md-8">
                          <select
                            v-model.number="model.user_type_id"
                            class="form-control"
                            :class="{
                              'is-invalid': errors.has('user_type_id')
                            }"
                          >
                            <option :value="1">Office Staff</option>
                            <option :value="2">Supper Dealer</option>
                            <option :value="3">Dealer</option>
                          </select>
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('user_type_id')"
                          >
                            {{ errors.first('user_type_id') }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="row form-group"
                        v-if="model.user_type_id != 1"
                      >
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.dealer')
                        }}</label>
                        <div class="col-md-8">
                          <a-select
                            v-model="model.dealer_id"
                            class="ts-w-full"
                            optionFilterProp="children"
                            :showSearch="true"
                            :options="dealer_profiles"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                          ></a-select>
                          <div class="validate" v-if="errors.has('dealer_id')">
                            {{ errors.first('dealer_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ts-loading-banner>
                </div>
                <!-- role component -->
                <role-list v-model="model" />
              </div>
              <div class="col-md-6">
                <permission-component v-model="model" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <ts-button
                  class="mr-2"
                  @click.prevent="$router.push({ name: 'user' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  color="primary"
                  :waiting="waiting"
                  @click.prevent="onUpdate"
                  >{{ $t('update') }}</ts-button
                >
              </div>
            </div>
          </fieldset>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { transform } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import RoleList from './components/role-component'
import PermissionComponent from './components/permission-component'

export default {
  name: 'UserCreateEdit',
  components: {
    RoleList,
    PermissionComponent
  },
  data() {
    return {
      loading: false,
      waiting: false,
      dealer_profiles: [],
      errors: new Errors(),
      model: {
        user_id: 0,
        dealer_id: null,
        username: null,
        user_type_id: null,
        name: null,
        password: null,
        password_confirmation: null,
        roles: [],
        permissions: []
      }
    }
  },
  created() {
    this.setEditData()
    this.fetchDealer()
  },
  computed: {
    ...mapState('security/user', ['edit_data'])
  },
  methods: {
    ...mapActions('security/user', ['getDealer']),
    onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('security/user/update', {
          id: this.model.user_id,
          ...this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'user' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.user_id = this.edit_data.user_id
        this.model.dealer_id = this.edit_data.dealer_id
        this.model.user_type_id = this.edit_data.user_type_id
        this.model.username = this.edit_data.user_name
        this.model.name = this.edit_data.name
        this.model.password = '012345678' // this password value no update
        this.model.password_confirmation = '012345678'
        this.model.roles = this.edit_data.roles.map(el => el.id)
        this.model.permissions = this.edit_data.permissions.map(el => el.id)
      }
    },
    clearInput() {
      this.model.user_id = 0
      this.model.username = null
      this.model.name = null
      this.model.password = null
      this.model.password_confirmation = null
      this.model.roles = []
      this.model.permissions = []
    },
    fetchDealer() {
      this.loading = true
      this.getDealer()
        .then(response => {
          this.dealer_profiles = response.data.map(el => ({
            value: el.dealer_id,
            label: el.dealer_name
          }))
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
